import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { NavLink, useParams } from "react-router-dom";
import { useGetSurveyByIdQuery } from "../../../features/surveys/surveysApiSlice";
import Iconify from "../../../components/iconify";
import SurveyEvaluationView from "./SurveyEvaluationView";
import Loading from "../../../components/spinners/Loading";

function SurveyEvaluation() {
  const { surveyId } = useParams();
  const { data, isLoading, isFetching } = useGetSurveyByIdQuery(surveyId);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  return (
    <Box sx={{ ml: 3 }}>
      <Button
        component={NavLink}
        to={"/dashboard/survey"}
        // onClick={() => handleChangeMenuState("/dashboard/files")}
        variant="contained"
        color="warning"
        sx={{ minWidth: 100, mb: 2 }}
        startIcon={<Iconify icon="mdi:arrow-left" />}
      >
        zurück
      </Button>
      <Typography textAlign={"left"} variant="h2">
        Auswertung
      </Typography>
      {/* <SurveyEvaluationPieChart
        title="Hier den Titel der Frage"
        chartData={[
          { label: "Fehler", value: 20 },
          {
            label: "Beschwerden",
            value: 30,
          },
          { label: "Risiken", value: 50 },
        ]}
        chartColors={[
          "#d9f3f2",
          "#aee3e4",
          "#48aead",
          // theme.palette.warning.main,
          // theme.palette.primary.main,
        ]}
      /> */}

      {data?.survey && (
        <SurveyEvaluationView
          surveyQuestions={data?.survey?.surveyQuestions}
          surveyAnswers={data?.survey?.surveyAnswers}
        />
      )}
    </Box>
  );
}

SurveyEvaluation.propTypes = {};

export default SurveyEvaluation;
